import Vue from 'vue'
import VueRouter from 'vue-router'
import Start from '@/views/Start'
import Home from '@/views/Home'
import Demo from '@/views/Demo'
import Price from '@/views/Price'
import About from '@/views/About'

import WhyCRM from '@/views/CRM/WhyCRM'
import WhatIsCRM from '@/views/CRM/WhatIsCRM'
import ChooseCRM from '@/views/CRM/ChooseCRM'
import CRMInSwedish from '@/views/CRM/CRMInSwedish'

import Privacy from '@/views/Privacy'
import NoPage from '@/views/404'

import Navbar from '@/components/Navbar'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: Home,
    // redirect: '/sv/',
  },
  {
    path: '/:catchAll(.*)',
    redirect: '/',
  },

  {
    path: '/sv',
    name: 'sv',
    component: Navbar,
    children: [
      {
        path: '',
        name: 'Start',
        component: Start,
      },
      {
        path: 'crm/pris',
        name: 'Price',
        component: Price,
      },
      {
        path: 'demo',
        name: 'Demo',
        component: Demo,
      },
      {
        path: 'om-oss',
        name: 'About',
        component: About,
      },

      {
        path: 'crm/vad-ar-crm-system',
        name: 'WhatIsCRM',
        component: WhatIsCRM,
      },
      {
        path: 'crm/varfor-crm',
        name: 'WhyCRM',
        component: WhyCRM,
      },
      {
        path: 'crm/valja-crm-system',
        name: 'ChooseCRM',
        component: ChooseCRM,
      },
      {
        path: 'crm/crm-pa-svenska',
        name: 'CRMInSwedish',
        component: CRMInSwedish,
      },
      {
        path: 'privacy',
        name: 'privacy',
        component: Privacy,
      },
    ],
  },

  {
    path: '*',
    component: NoPage,
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return { x: 0, y: 0 }
  },
})

export default router
